import React from 'react';
import {getCurrentUserId, getJwt} from '../../services/authService';
import Form from '../common/Form'
// import Joi from "joi-browser";
import {Link} from 'react-router-dom'

class ConnectViberModal extends Form {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                token: ''
            },
            unsuccessfulPostCall: false,
            errors: {},
            selectedModal: '',
            copySuccess: '',
            copySuccess2: '',
            webPushId: '',
            userId: getCurrentUserId(),
        };
    }

    // schema = {
    //     token: Joi.string().label("Token")
    // };

    closeModal = () => {
        this.setState({
            selectedModal: '',
            copySuccess: '',
            copySuccess2: ''
        })
    };

    doSubmit = () => {
        this.setState({
            selectedModal: '',
            copySuccess: '',
            copySuccess2: ''
        })
        this.props.onClickAway()
    };

    renderViberBusinessMessages = () => {
        return <div className="onboarding-panel">
            {/*<div className='top-left-back'>*/}
            {/*    <h3 onClick={this.closeModal}>{'<'} Back </h3>*/}
            {/*</div>*/}
            {/*<div className='top-right-x'>*/}
            {/*    <h3><Link to="#" onClick={this.props.onClickAway}><img className="x-styles"*/}
            {/*                                                           src="/img/greyCloseButton.png"/></Link></h3>*/}
            {/*</div>*/}
            {/*<div className="header-container">*/}
            {/*    <h1>Instructions</h1>*/}
            {/*</div>*/}
            {/*<div className="main-part-container">*/}
            {/*    <div className="title-container">*/}
            {/*        <div className="logo-container">*/}
            {/*            <img className="" src="/img/wordpress-simple@2x.png" alt="wordpress-logo"/>*/}
            {/*        </div>*/}
            {/*        <div className="text-container">*/}
            {/*            <h3>WordPress websites</h3>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <p>*/}
            {/*        For WordPress websites, <strong>Emitto</strong> developed an <strong>Emitto*/}
            {/*        Plugin</strong>.<br/><br/>*/}

            {/*        <strong>Emitto WordPress plugin</strong> creates a simple pop-up on your website which makes using*/}
            {/*        your Emitto features easy and can help you easily turn your visitors to active subscribers. This*/}
            {/*        fully customizable popup has two options for your users:<br/><br/>*/}

            {/*        <strong>- Turn on web-push notifications for this website</strong><br/>*/}
            {/*        <strong>- Subscribe to Facebook Chatbot</strong><br/><br/>*/}

            {/*        Your potential subscriber can choose one of those, or both options.*/}
            {/*    </p>*/}
            {/*    <h2>Installation</h2>*/}
            {/*    <div className='list-item-container'>*/}
            {/*        <h3><span>1</span>Download Emitto Plugin</h3>*/}
            {/*        <p><a href="https://downloads.wordpress.org/plugin/emitto.zip">Click here</a> to download Emitto*/}
            {/*            plugin.</p>*/}
            {/*    </div>*/}
            {/*    <div className='list-item-container'>*/}
            {/*        <h3><span>2</span>Install plugin to your WordPress website</h3>*/}
            {/*        <p>In your WordPress dashboard, in plugin section, choose “<strong>Add New</strong>” and click*/}
            {/*            “<strong>Upload plugin</strong>”. Upload previously downloaded .zip file. After installation,*/}
            {/*            click “Activate” to <strong>activate</strong> plugin.</p>*/}
            {/*    </div>*/}
            {/*    <div className='list-item-container'>*/}
            {/*        <h3><span>3</span>Plugin settings <img src="/img/not-wordpress.png"/></h3>*/}
            {/*        <p>Emitto icon <img src="/img/not-wordpress.png"/> will appear in your admin menu which opens*/}
            {/*            Emitto plugin activation and popup customization settings.<br/></p>*/}
            {/*        <p>Insert your unique Emitto ID in the input field in the plugin settings.</p>*/}
            {/*        <form>*/}
            {/*            <textarea*/}
            {/*                ref={(textarea) => this.textArea = textarea}*/}
            {/*                value={localStorage.getItem('webPushId')}*/}
            {/*            />*/}
            {/*            <button onClick={(e) => this.copyToClipboard(e)}>Copy</button>*/}
            {/*        </form>*/}
            {/*        {this.state.copySuccess ?*/}
            {/*            <p className="success-text copy-success">{this.state.copySuccess}</p> : ''}*/}

            {/*        <p>Save changes. After this, your popup is activated and it will be shown to your website visitors.*/}
            {/*            🙌</p>*/}
            {/*    </div>*/}
            {/*    <div className='list-item-container'>*/}
            {/*        <h3><span>4</span>See it in action</h3>*/}
            {/*        <p>Visit your website to see how it will look like when someone lands on your website.</p>*/}
            {/*    </div>*/}
            {/*    <div className="email-instructions-container">*/}
            {/*        <h3><img src="/img/envelope_icon.png"/>Email instructions to developer</h3>*/}
            {/*        <p>Email instructions to developer to insert Emitto code for you.</p>*/}
            {/*    </div>*/}
            {/*    <div className='text-center'>*/}
            {/*        <button className='btn-action btn-sm ' onClick={this.props.onClickAway}>Close</button>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    };

    renderViberPublicChannel = () => {
        return <div className="onboarding-panel">
            <div className='top-left-back'>
                <h3 onClick={this.closeModal}>{'<'} Back </h3>
            </div>
            <div className='top-right-x'>
                <h3><Link to="#" onClick={this.props.onClickAway}><img className="x-styles"
                                                                       src="/img/greyCloseButton.png"/></Link></h3>
            </div>
            <div className="header-container">
                <h1 className='main-title'>Instructions</h1>
            </div>
            <div className="main-part-container">
                <h3>Viber Public Channel</h3>
                <p className="no-margin-left">Used to send messages to group of people at the same time.</p>
                <h2>Installation</h2>
                <div className='list-item-container popup-pics'>
                    <h3><span>1</span>You need an active Viber account.</h3>
                    <p>Use your existing Viber account, or download the Viber app for your phone and create an account using your phone number if you don’t have one already.</p>
                </div>
                <div className='list-item-container add-seconds'>
                    <h3><span>2</span>Create a Viber Bot</h3>
                    <p>Do it on <a href={'https://nba.com'}> this link </a> (takes about 3 minutes).<br/>
                        You can use your existing private account/number, since your account will be set as the Bot administrator and will not impact any of your personal conversations. The URI you set up while creating your Bot, will be a part of your public / shareable link, so make sure you choose one that makes sense.</p>
                </div>
                <div className='list-item-container expiration-days'>
                    <h3><span>3</span>Connect Emmito.</h3>
                    <p>Paste the Authorization token code from the bot here to connect with Emitto.<br/><br/></p>
                    <img className="full-width-image" src="/img/viber_token_screenshot.jpg" alt="Viber token screenshot"/>
                </div>
                <div className="flex-middle">
                    <form onSubmit={this.handleFormSubmit}>
                        <div className="form-group m-xl-b">
                            <label>Enter Viber Token</label>
                            {this.renderInput("token", "https://yourdomain.com", "Enter Your Viber Token")}
                        </div>
                        <button type="submit" className="btn-action btn-m viber-connect-button">Connect {!this.state.spinnerActive ?
                            ""
                            :
                            <i className='fa fa-spin fa-spinner'></i>}
                        </button>
                    </form>

                </div>
            </div>
        </div>
    };

    selectModal = (selectedModal) => {
        if (this.state.selectedSource !== selectedModal) {
            this.setState({
                selectedModal: selectedModal
            })
        }
    };

    componentDidMount() {
        let sources = this.props.sources;
        let selectedSource = this.props.selectedSource;
        //let feedsShared = this.props.feeds_shared;
        let selectedSourceData = sources.find((source) => source.id.toString() === selectedSource.toString())
        //let selectedFeedSharedData = feedsShared ? feedsShared.find((source) => source.id.toString() === selectedSource.toString()) : []
        let webPushId = selectedSourceData ? selectedSourceData.web_push_id :
            //selectedFeedSharedData ? selectedFeedSharedData.web_push_id :
                '';
        localStorage.setItem('webPushId', webPushId);
        this.setState({
            webPushId: webPushId
        });

    }

    render() {
        let {visible_modal, onClickAway, teams, team_id, feed_name} = this.props;
// console.log("ReassignFeedModal team_id", team_id);
        return (

            <div id="teamModal" className="text-left instructions-modal modal in"
                 style={visible_modal ? {display: "block"} : {display: "none"}}>

                {/*<div className={this.state.selectedModal === '' ? "modal-content" : "modal-content wide-modal"}>*/}
                {/*    {this.state.selectedModal === 'viber-business-messages' || this.state.selectedModal === 'viber-public-channel' ?*/}
                {/*            this.renderViberPublicChannel() :*/}
                {/*            <div className="onboarding-panel">*/}
                {/*                <div className='top-right-x'>*/}
                {/*                    <h3><Link to="#" onClick={onClickAway}><img className="x-styles"*/}
                {/*                                                                src="/img/greyCloseButton.png"/></Link>*/}
                {/*                    </h3>*/}
                {/*                </div>*/}
                {/*                <h1 className='onboarding-title'>Connect Viber</h1>*/}
                {/*                <p>What type of Viber account you want to use?</p>*/}
                {/*                /!*<div className="single-option-container" onClick={() => this.selectModal('viber-business-messages')}>*!/*/}
                {/*                <div className="single-option-container">*/}
                {/*                    <div className="text-container">*/}
                {/*                        <h3>Viber Business Messages</h3>*/}
                {/*                        <p>Used to send direct 1 on 1 messages to your subscriber.</p>*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*                <div className="single-option-container"*/}
                {/*                     onClick={() => this.selectModal('viber-public-channel')}>*/}
                {/*                    <div className="text-container">*/}
                {/*                        <h3>Viber Public Channel</h3>*/}
                {/*                        <p>Used to send messages to group of people at the same time.</p>*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*    }*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default ConnectViberModal;